import { CloseText } from 'owa-locstrings/lib/strings/closetext.locstring.json';
import { SettingsText, FilterText } from './FilePickerCommandBar.locstring.json';
import loc from 'owa-localize';
import getAriaLabelForViewSwitcher from './utils/getAriaLabelForViewSwitcher';
import showFilePickerOption from './utils/showFilePickerOption';
import { observer } from 'mobx-react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { FilePickerViewType, viewTypeIcon } from '../types/FilePickerViewSwitcher';
import FilePickerFilterView from './Filter/FilePickerFilterView';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';

import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./FilePickerCommandBar.scss');
const commandBarStyles = { root: { padding: 0 } };

export interface FilePickerCommandBarProps {
    toggleSelectedFilePickerView: () => void;
    onCloseFilePickerClicked: () => void;
    selectedFilePickerView?: FilePickerViewType;
    supportedFilePickerViews: FilePickerViewType[];
    filterOptions: AttachmentItemsFilterBy[];
    selectedFilterOption: AttachmentItemsFilterBy;
    showFilterOptionsMenu: boolean;
    onFilterIconClicked: () => void;
    onFilterOptionClicked: (selectedFilter: AttachmentItemsFilterBy) => void;
    onFilterMenuDismissed: () => void;
    isProviderListView: boolean;
}

@observer
export default class FilePickerCommandBar extends React.Component<FilePickerCommandBarProps, {}> {
    private commandBarDiv: HTMLElement;

    render() {
        const commandBarItems = this.getCommandBarItems(
            this.props.selectedFilePickerView,
            this.props.supportedFilePickerViews,
            this.props.toggleSelectedFilePickerView,
            this.props.filterOptions,
            this.props.isProviderListView
        );

        return (
            <div ref={c => (this.commandBarDiv = c)}>
                <CommandBar
                    items={[]}
                    farItems={commandBarItems}
                    className={styles.commandBar}
                    data-is-focusable={true}
                    styles={commandBarStyles}
                />
                {this.props.showFilterOptionsMenu && (
                    <FilePickerFilterView
                        filterOptions={this.props.filterOptions}
                        selectedFilterOption={this.props.selectedFilterOption}
                        getTargetElement={this.commandBarDiv}
                        onFilterOptionClicked={this.props.onFilterOptionClicked}
                        onFilterMenuDismissed={this.props.onFilterMenuDismissed}
                    />
                )}
            </div>
        );
    }

    private getCommandBarItems = (
        selectedView: FilePickerViewType,
        supportedViews: FilePickerViewType[],
        toggleFilePickerView: () => void,
        filterOptions: AttachmentItemsFilterBy[],
        isProviderListView: boolean
    ): IContextualMenuItem[] => {
        const commandBarItems: IContextualMenuItem[] = [
            {
                className: styles.settingsButton,
                key: 'Settings',
                iconProps: { iconName: ControlIcons.Settings },
                icon: ControlIcons.Settings,
                ariaLabel: loc(SettingsText),
                title: loc(SettingsText),
                onClick: this.onSettingsClicked,
            },
            {
                key: 'CloseFilePicker',
                iconProps: { iconName: ControlIcons.Cancel },
                ariaLabel: loc(CloseText),
                title: loc(CloseText),
                onClick: this.props.onCloseFilePickerClicked,
            },
        ];

        if (isProviderListView) {
            // We only add the view switch icon if we have a view switcher, and at least two views
            // for it to switch between.
            if (selectedView !== null && supportedViews && supportedViews.length !== 1) {
                commandBarItems.unshift({
                    key: 'viewSwitcher',
                    ariaLabel: getAriaLabelForViewSwitcher(selectedView, supportedViews),
                    title: getAriaLabelForViewSwitcher(selectedView, supportedViews),
                    iconProps: { iconName: viewTypeIcon[selectedView]() },
                    onClick: toggleFilePickerView,
                });
            }

            // We only add the filter icon if the provider has filter options defined.
            if (filterOptions.length > 0) {
                commandBarItems.unshift({
                    key: 'Filter',
                    iconProps: { iconName: ControlIcons.Filter },
                    ariaLabel: loc(FilterText),
                    title: loc(FilterText),
                    onClick: this.props.onFilterIconClicked,
                });
            }
        }

        return commandBarItems;
    };

    private onSettingsClicked() {
        showFilePickerOption();
    }
}
